import React, { useState } from "react";
import TextInput from "../../components/commons/TextInput";
import Button from "../../components/commons/Button";
import Dropdown from "../../components/commons/Dropdown";
import { useLocation, useNavigate } from "react-router-dom";

const HeroSection = () => {
  const options = [
    { value: "", label: "Filter By" },
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const queries = new URLSearchParams(useLocation().search)
  const preValue = queries.get('search') ? queries.get('search') : ''
  const [searchText, setSearchText] = useState('')
  const navigate = useNavigate()

  const handleSearch = () => {
    navigate(`/marketplace/categories?search=${searchText}`)
  }
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <div className="max-lg:-mt-20 max-lg:-mx-6">
      {/* <div className="container px-5 mx-auto relative after:content-[''] after:w-[360px] after:left-[100%] after:h-[360px] after:bottom-[90%] after:blur-[200px] after:bg-primary after:rounded-full after:absolute after:z-[1]"> */}
      <div className="container lg:px-5 mx-auto relative">
        <img
          src="/assets/decorations/marketplace_decoration_1.png"
          className="max-w-[180px] lg:hidden lg:max-w-[unset] absolute left-[-1.5rem] top-[25%] translate-y-[-50%] z-[1] drop-shadow-[0px_4px_40px_#fff5]"
        />
        <img
          src="/assets/decorations/marketplace_decoration_3.png"
          // className="hidden lg:block absolute right-[-3rem] top-[50%] translate-y-[-60%] z-[2] drop-shadow-[0px_4px_40px_#fff5] pointer-events-none"
          className="block absolute max-w-[140px] lg:max-w-[200px] right-[-2rem] top-[25%] translate-y-[-50%] lg:top-[50%] lg:translate-y-[-60%] z-[2] drop-shadow-[0px_4px_40px_#fff5] pointer-events-none"
        />
        <div className="text-white product-ask-section max-lg:!border-none lg:bg-white/5 backdrop-blur-md flex flex-col-reverse lg:flex-row">
          <div className="max-lg:ml-1 flex flex-col w-full p-5 py-10 lg:p-12">
            <h2 className="uppercase font-aero text-left text-[32px] lg:text-[48px]  leading-[1.1]">
              Buy and sell
              <span className="gradient-text font-aero">
                <br />
                with Ease
              </span>
            </h2>
            <p className="w-full text-xs lg:text-base mt-5 lg:text-left max-w-[370px] opacity-60 font-light">
              From rare finds to the latest releases, we provide a space where
              enthusiasts can buy, sell, and exchange cards with confidence.
            </p>
            <div className="mt-6 flex flex-col lg:flex-row items-center gap-4 w-full max-lg:hidden">
              {/* <img
            src="/assets/decorations/homepage_decoration_9.png"
            className="absolute top-[-2rem] pointer-events-none w-[700px]"
          /> */}
              {/* <div className="absolute pointer-events-none w-[360px] h-[360px] bg-primary blur-[300px] rounded-full left-[50%] translate-x-[-50%] bottom-[100%]" /> */}
              {/* <Dropdown
                options={options}
                placeholder="Filter by"
                onChange={handleDropdownChange}
                className="w-full lg:max-w-[150px]"
              /> */}
              <div className="flex items-center w-full space-x-4">
                <TextInput placeholder="Search for cards" divClassName="max-w-[460px] group focus-within:border-[#1AB6F9] transition" onChange={(v) => setSearchText(v)} defaultValue={preValue} value={searchText} onKeyDown={handleKeyDown} />
                <Button isActive divClassName="border-style-decoration-container" buttonClassName="border-style-decoration" onClick={handleSearch}>Search</Button>
              </div>
            </div>
          </div>

          {/*  */}
          <div className="h-[420px] lg:h-[unset] w-full lg:max-w-[480px] relative pointer-events-none z-[2] overflow-hidden">
            <img
              src="/assets/decorations/marketplace_decoration_1.png"
              className="hidden lg:block lg:max-w-[200px] absolute left-[-1.5rem] lg:left-[2rem] bottom-[50%] translate-y-[50%] z-[1] drop-shadow-[0px_4px_40px_#fff5]"
            />
            <img
              src="/assets/decorations/marketplace_decoration_2.png"
              // className="block max-w-[190px] bottom-[-4.5rem] lg:max-w-[unset] absolute right-[1.5rem] lg:bottom-[-6.5rem] z-[1] drop-shadow-[0px_4px_40px_#fff5]"
              className="block max-w-[180px] bottom-[-4.5rem] lg:max-w-[200px] absolute right-[7.5%] lg:right-[-2.5rem] lg:translate-x-[-50%] translate-x-[-7.5%] lg:bottom-[-6.5rem] z-[1] drop-shadow-[0px_4px_40px_#fff5]"
            />

            <img
              src="/assets/decorations/marketplace_decoration_4.png"
              className="max-w-[130px] lg:max-w-[150px] block absolute top-[-2.5rem] lg:top-[-3.5rem] right-[3.5rem] lg:right-[6rem] z-[1] drop-shadow-[0px_4px_40px_#fff5]"
            />
            <div className="w-full h-full bg-primary-gradient product-ask-section"></div>
            {/* <div className="h-[480px] w-full max-w-[480px] bg-primary-gradient"></div> */}
            {/* <img src="/assets/decorations/marketplace_decoration.png" /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
